import { ReactNode } from 'react';

interface IHelpSlideProps {
  readonly children: ReactNode;
}

export function HelpSlide(props: IHelpSlideProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        textAlign: 'center',
      }}
    >
      {props.children}
    </div>
  );
}
